module.exports = __webpack_public_path__ + "static/img/qiangchai.f061a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/qiangchai.png
// module id = pVyT
// module chunks = 24